export const fieldsValidationSchema = (fields) => {
  let schemaObj = {};
  fields.map((field) => {
    const fieldName = { [field.name]: field['validation'] };
    schemaObj = { ...schemaObj, ...fieldName };
  });

  return schemaObj;
};
